import React from 'react';
import {Col, Row} from "reactstrap";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class Task extends React.Component {

    render() {

        const {handleChangePage, pagesData} = this.props;

        return <div className={'ilead-tools-group'}>

            <div>
                <Row>
                    <Col sm={12}>Owning</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to take responsibility</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToTakeResponsibility']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToTakeResponsibility')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to deliver every time</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDeliverEveryTime']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDeliverEveryTime')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to take control</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToTakeControl']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToTakeControl')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to know when and how to take risks</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToKnowWhenAndHowToTakeRisks']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToKnowWhenAndHowToTakeRisks')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Driving</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to maintain momentum</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToMaintainMomentum']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToMaintainMomentum')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to cope with setbacks</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToCopeWithSetbacks']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToCopeWithSetbacks')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to formulate action plans</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToFormulateActionPlans']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToFormulateActionPlans')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to win and manage resources</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToWinAndManageResources']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToWinAndManageResources')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Engaging</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to communicate your vision</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToCommunicateYourVision']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToCommunicateYourVision')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to delegate</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToDelegate']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToDelegate')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to engage others to deliver</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToEngageOthersToDeliver']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToEngageOthersToDeliver')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col sm={12}>Sustaining</Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to build resilience</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToBuildResilience']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToBuildResilience')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to use optimism to achieve</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToUseOptimismToAchieve']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToUseOptimismToAchieve')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} xs={4} lg={6} xl={7}>How to get the most out of yourself</Col>
                    <Col sm={3} xs={4} lg={3} xl={3} className={'row-complete'}>
                        {pagesData?.['HowToGetTheMostOutOfYourself']?.status ? <>
                                <img src="http://pktech.pearnkandoladigital.com/theme/pkileadrdn/pix/completed-icon.png" alt=""/>
                                Complete</>
                            : 'Incomplete'
                        }

                    </Col>
                    <Col sm={3} xs={4} lg={3} xl={2} className="d-flex align-items-center" onClick={handleChangePage('HowToGetTheMostOutOfYourself')}>
                        <span className={'ilead-tools-review'}>Review <FontAwesomeIcon icon={faChevronRight} /></span>
                    </Col>
                </Row>
            </div>
        </div>;
    }
}